import React from 'react';
import Layout from '../../components/Layout';
import Seo from '../../components/Seo';
import SidebarLayout from '../../components/SidebarLayout';

const WellsFargo = () => {
    return (<>
        <Seo
            title="Wells Fargo Frontend React JS Interview Questions"
            description="Wells Fargo Frontend React JS Interview Questions"
        />
        <div className="card">

            <div className="card-content">
                {/* <div className="media">
                    <div className="media-left">
                    <figure className="image is-48x48">
                    <img src="https://bulma.io/images/placeholders/96x96.png" alt="Placeholder image" />
                    </figure>
                    </div>
                    <div className="media-content">
                    <p className="title is-4">Shishir</p>
                    <p className="subtitle is-6">@shi2rsingh</p>
                    </div>
                    </div>
                */}
                <div className="content">
                    <p className='title is-5'>Telephonic Round</p>
                    <ol>
                        <li>What is promise </li>
                        <li>What is race  in promise</li>
                        <li>What is middleware redux thunk redux saga </li>
                        <li>If you have a large data set pagination will be on server side or client side and why </li>
                        <li>How you call in API using axios </li>
                        <li>List some of the ECMAScript 6 features</li>
                        <li>What is the benefit of arrow functions in JavaScript </li>
                        <li>Define this in JavaScript </li>
                        <li>Explain redux flow </li>
                        <li>Name some array functions in JavaScript </li>
                        <li>How to identify type of a variable</li>
                        <li>What is the type of null ?</li>
                        <li>Data types available in JavaScript </li>
                        <li>What is the value of this in browser console </li>
                        <li>What is the value of this in arrow function and normal function </li>
                        <li>What is hoisting in JavaScript </li>
                        <li>What is immediately invoked function </li>
                        <li>What is the data flow of react </li>
                        <li>How do you pass data between components from parent to child </li>
                    </ol>
                    <p className='title is-5'>Coding Round</p>
                    <ol>
                        <li>How to focus on element in react. Write a program </li>
                        <li>Why h1 tag can't be focused  </li>
                        <li>Remove duplicates from an array </li>
                        <li>How to combine two arrays </li>
                        <li>Create a login form with username password and view password button which will toggle between password and text field</li>
                        <li>Create a layout with the left hand side as body and right hand side as sidebar </li>
                        <li>What is useMemo and useCallback </li>
                        <li>Define all the hooks in react </li>
                        <li>How will you call API and where you will call API in React</li>
                        <li>What is the use of context</li>
                        <li>Read about accessibility in HTML </li>
                        <li>What is tab index in HTML </li>
                        <li>How do you rate yourself on plain JavaScript and react</li>
                        <li>What is the benefit of context API and useContext </li>
                        <li>What is the use of refs in react </li>
                    </ol>
                    <p className='title is-5'>Managerial Round</p>
                    <ol>
                        <li>What is generator function in JavaScript</li>
                        <li>Question related to accessibility (Where, What)</li>
                        <li>Write a program to convert aaabbccxx --> a3b2c2x2</li>
                        <li>Write a program to convert aaabbccxxaa --> a3b2c2x2a2</li>
                        <li>Minor technical discussions</li>
                        <li>Unique array element.</li>
                        <li>Challenging task</li>
                        <li>Notcie period discussions </li>
                        <li>Error Boundary</li>
                        <li>How do you learn (General Discussions)</li>
                    </ol>
                    <br />
                    <time datetime="2021-07-23">11:09 PM - 23 Jul 2021</time>
                </div>
            </div>
        </div>
    </>
    );
}


const WellsFargoWithSidebarLayout = () => (
    <Layout>
        <SidebarLayout>
            <WellsFargo />
        </SidebarLayout>
    </Layout>
);

export default WellsFargoWithSidebarLayout;